// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawer_body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.drawer_body * {
  padding: 0;
  margin: 0;
}

.drawer_subtitle {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.03px;
  padding-bottom: 8px !important;
}
@media (min-width: 770px) {
  .drawer_subtitle {
    padding-bottom: 24px !important;
  }
}

.drawer_section_summary {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px !important;
  border-bottom: dashed 1px #b3b3b3;
}

.drawer_summary_title {
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.2px;
  padding-bottom: 8px !important;
}
@media (min-width: 770px) {
  .drawer_summary_title {
    padding-bottom: 16px !important;
  }
}

.drawer_summary_span {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.drawer_summary_span_title {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: #444444;
}
.drawer_summary_span_value {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.2px;
  color: #000000;
}

.drawer_btn_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.drawer_btn_container button {
  width: 95%;
}
@media (min-width: 770px) {
  .drawer_btn_container {
    flex-direction: row;
    justify-content: flex-end;
  }
  .drawer_btn_container button {
    width: 35%;
  }
}

.drawer_footer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px !important;
}
@media (min-width: 770px) {
  .drawer_footer {
    gap: 24px;
    padding-top: 48px !important;
  }
}

.drawer_body_skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.drawer_subtitle_skeleton {
  width: 60%;
  height: 16px;
  margin-bottom: 8px;
}
@media (min-width: 770px) {
  .drawer_subtitle_skeleton {
    margin-bottom: 24px;
  }
}

.drawer_section_summary_skeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 24px;
  border-bottom: dashed 1px #b3b3b3;
}

.drawer_summary_title_skeleton {
  width: 50%;
  height: 18px;
  margin-bottom: 8px;
}
@media (min-width: 7770px) {
  .drawer_summary_title_skeleton {
    margin-bottom: 16px;
  }
}

.drawer_summary_span_skeleton {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.drawer_summary_span_title_skeleton {
  width: 45%;
  height: 20px;
}

.drawer_summary_span_value_skeleton {
  width: 45%;
  height: 24px;
}

.drawer_btn_container_skeleton {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
}
@media (min-width: 770px) {
  .drawer_btn_container_skeleton {
    flex-direction: row;
    justify-content: flex-end;
  }
}

.button_skeleton {
  width: 95%;
  height: 40px;
}
@media (min-width: 770px) {
  .button_skeleton {
    width: 35%;
    height: 40px;
  }
}

.drawer_footer_skeleton {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
}
@media (min-width: 770px) {
  .drawer_footer_skeleton {
    padding-top: 48px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/utils-ui/components/drawer/drawer.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mJAAA;AACF;AACE;EACE,UAAA;EACA,SAAA;AACJ;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,8BAAA;AACF;AAAE;EANF;IAOI,+BAAA;EAGF;AACF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,+BAAA;EACA,iCAAA;AAIF;;AAFA;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,8BAAA;AAKF;AAJE;EALF;IAMI,+BAAA;EAOF;AACF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAQF;AAPE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AASJ;AAPE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AASJ;;AANA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AASF;AARE;EACE,UAAA;AAUJ;AARE;EATF;IAUI,mBAAA;IACA,yBAAA;EAWF;EAVE;IACE,UAAA;EAYJ;AACF;;AARA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,2BAAA;AAWF;AAVE;EALF;IAMI,SAAA;IACA,4BAAA;EAaF;AACF;;AAVA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAaF;;AAVA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AAaF;AAZE;EAJF;IAKI,mBAAA;EAeF;AACF;;AAZA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;EACA,iCAAA;AAeF;;AAZA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AAeF;AAdE;EAJF;IAKI,mBAAA;EAiBF;AACF;;AAdA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAiBF;;AAdA;EACE,UAAA;EACA,YAAA;AAiBF;;AAdA;EACE,UAAA;EACA,YAAA;AAiBF;;AAdA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAiBF;AAhBE;EALF;IAMI,mBAAA;IACA,yBAAA;EAmBF;AACF;;AAhBA;EACE,UAAA;EACA,YAAA;AAmBF;AAlBE;EAHF;IAII,UAAA;IACA,YAAA;EAqBF;AACF;;AAlBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AAqBF;AApBE;EALF;IAMI,iBAAA;EAuBF;AACF","sourcesContent":[".drawer_body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,\n    Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  * {\n    padding: 0;\n    margin: 0;\n  }\n}\n.drawer_subtitle {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.03px;\n  padding-bottom: 8px !important;\n  @media (min-width: 770px) {\n    padding-bottom: 24px !important;\n  }\n}\n.drawer_section_summary {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 24px !important;\n  border-bottom: dashed 1px #b3b3b3;\n}\n.drawer_summary_title {\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: 0.2px;\n  padding-bottom: 8px !important;\n  @media (min-width: 770px) {\n    padding-bottom: 16px !important;\n  }\n}\n.drawer_summary_span {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  &_title {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0.2px;\n    color: #444444;\n  }\n  &_value {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.2px;\n    color: #000000;\n  }\n}\n.drawer_btn_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  button {\n    width: 95%;\n  }\n  @media (min-width: 770px) {\n    flex-direction: row;\n    justify-content: flex-end;\n    button {\n      width: 35%;\n    }\n  }\n}\n\n.drawer_footer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-top: 8px !important;\n  @media (min-width: 770px) {\n    gap: 24px;\n    padding-top: 48px !important;\n  }\n}\n\n.drawer_body_skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.drawer_subtitle_skeleton {\n  width: 60%;\n  height: 16px;\n  margin-bottom: 8px;\n  @media (min-width: 770px) {\n    margin-bottom: 24px;\n  }\n}\n\n.drawer_section_summary_skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 24px;\n  border-bottom: dashed 1px #b3b3b3;\n}\n\n.drawer_summary_title_skeleton {\n  width: 50%;\n  height: 18px;\n  margin-bottom: 8px;\n  @media (min-width: 7770px) {\n    margin-bottom: 16px;\n  }\n}\n\n.drawer_summary_span_skeleton {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.drawer_summary_span_title_skeleton {\n  width: 45%;\n  height: 20px;\n}\n\n.drawer_summary_span_value_skeleton {\n  width: 45%;\n  height: 24px;\n}\n\n.drawer_btn_container_skeleton {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 16px;\n  @media (min-width: 770px) {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n\n.button_skeleton {\n  width: 95%;\n  height: 40px;\n  @media (min-width: 770px) {\n    width: 35%;\n    height: 40px;\n  }\n}\n\n.drawer_footer_skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding-top: 24px;\n  @media (min-width: 770px) {\n    padding-top: 48px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
